import React from "react";
import { useLanguage } from "../../../contexts/LanguageContext";

const PublicEmergencyFooter = () => {
  const { t } = useLanguage();

  return (
    <footer className="pub-footer">
      <p className="pub-footer__brand">EmergencyQR.in</p>
      <p className="pub-footer__line">{t("public.footerDpdpa")}</p>
      <p className="pub-footer__line">{t("public.footerEmergency")}</p>
      <a href="https://emergencyqr.in" className="pub-footer__link" target="_blank" rel="noopener noreferrer">
        emergencyqr.in
      </a>
    </footer>
  );
};

export default PublicEmergencyFooter;
